export const empty = [
  {
    head: "Sorry, we can't find that page!",
    desc: " Don't worry though, let’s get you back on track",
    image: "./Images/empty-states/Trustline-Page-Not-Found.svg",
    alt: "Sorry, the page you are looking for cannot be found.",
  },
];
